exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".customdropdown__white-btn{\n  border-radius: 5px;\n  background: #FFF;\n  padding: 1px;\n  display: -ms-flexbox;\n  display: flex;\n  border: none;\n}\n.customdropdown__white-btn-text{\n  font-weight: bold;\n  color: black;\n  padding: 2px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/CustomDropdown/customdropdown.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/CustomDropdown/customdropdown.css
// module chunks = 120